import { render, staticRenderFns } from "./auto-scroller.vue?vue&type=template&id=1df85e52&"
import script from "./auto-scroller.vue?vue&type=script&lang=js&"
export * from "./auto-scroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports